<template>
  <main class="contact">
    <div class="contact__wrapper">
      <div class="contact__social">
        <div class="contact__social__children">
          <staggering-transition :delay="textAnimationDelay">
            <h2>Studio</h2>
          </staggering-transition>
          <transition appear name="scaleLine">
            <div class="contact__social__line"/>
          </transition>
          <staggering-transition :delay="textAnimationDelay">
            <a
              v-hover-scale-mouse
              data-apollo-hover
              href="tel:+39 392 4085836">T. +39 392 4085836</a>
          </staggering-transition>
          <staggering-transition :delay="textAnimationDelay">
            <a
              v-hover-scale-mouse
              data-apollo-hover
              href="mailto:info@alessandrazanghi.studio">M. info@alessandrazanghi.studio</a>
          </staggering-transition>
        </div>
        <div class="contact__social__children">
          <staggering-transition :delay="textAnimationDelay">
            <h2>Social</h2>
          </staggering-transition>
          <transition appear name="scaleLine">
            <div class="contact__social__line"/>
          </transition>
          <staggering-transition :delay="textAnimationDelay">
            <a v-hover-scale-mouse
               data-apollo-hover
               target="_blank"
               href="https://www.instagram.com/gardalake_events/">Instagram</a>
          </staggering-transition>
        </div>
      </div>
      <div class="contact__form">
        <staggering-transition :delay="textAnimationDelay">
          <h2>Contact Me</h2>
        </staggering-transition>
        <transition appear name="appearForm">
          <Form/>
        </transition>
      </div>
    </div>
  </main>
</template>

<script>
import Form from '@/components/ContactForm.vue';
import StaggeringTransition from '@/components/StaggeringTransition.vue';

export default {
  name: 'Contact',

  data() {
    return {
      textAnimationDelay: 200,
    };
  },

  components: {
    StaggeringTransition,
    Form,
  },
};
</script>

<style lang="scss" scoped>
$margin-top: 20vw;
$margin-top-tablet: 20vw;
$margin-top-mobile: 30vw;

$horizontal-padding-mobile-s: 10vw;
$horizontal-padding-mobile: 13.6vw;

.contact {
  margin-bottom: 120px;

  @include mq(ipadL) {
    margin-bottom: 0;
  }

  &__wrapper {
    text-align: left;
    padding: $horizontal-padding-mobile-s $horizontal-padding-mobile-s 0;

    @include mq(mobileX) {
      padding: $horizontal-padding-mobile $horizontal-padding-mobile 0;
    }

    @include mq(mobileL) {
      margin: 0 auto;
      padding: $margin-top 0;
      max-width: 63vw;
    }
  }

  & + .contact {
    margin-top: rem(80px);
  }

  &__eyelet {
    margin-bottom: rem(70px);
  }

  &__content {
    p {
      max-width: 50%;
      margin-top: rem(100px);
    }
  }

  &__social {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    padding-top: rem(100px);

    &__children {
      flex: 0 0 100%;
      margin-bottom: 80px;

      @include mq(ipadP) {
        flex: 0 0 50%;
        flex-basis: calc(50% - #{rem(60px)});
        max-width: calc(50% - #{rem(60px)});
        margin-bottom: 0;

        text-align: left;
      }

      & ::v-deep p {
        margin: 0;
      }

      & p {
        @include fluid-type(375px, 1920px, 16px, 16px, 24px, 35px);
      }

      & h2 {
        @include fluid-type(375px, 1920px, 24px, 65px, 30px, 60px);
      }
    }

    &__line {
      transform-origin: left center;
      position: relative;
      width: 100%;
      height: 1px;

      margin: rem(15px) 0 rem(30px) 0;

      background: $color-dark-light;
    }
  }

  &__form {
    text-align: left;

    @include mq(ipadP) {
      margin-top: 160px;
    }

    & h2 {
      @include fluid-type(375px, 1920px, 24px, 65px, 30px, 60px);
      margin-bottom: 2rem;
    }
  }
}


/* animation */
.scaleLine {
  &-enter-active {
    transition: all 1s 1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  &-enter {
    transform: scaleX(0);
  }
}

.appearForm {
  &-enter-active {
    transition: opacity 2s cubic-bezier(0.895, 0.03, 0.685, 0.22),
    transform 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &-enter {
    opacity: 0;
    transform: translateY(20vh);
  }
}
</style>
